import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useReceivableModel } from "../receivableModel";
import { IReceivableDetail } from "../receivableService";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum } from "@/utils/utils";
import moment from "moment";


export function DataTable() {
    const {
        dataSource, pgCfg, loading, setDetailedDialog,
        loadData
    } = useReceivableModel();
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IReceivableDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '外贸合同号',
            width: 120,
            dataIndex: 'realCode',
            fixed: "left",
            ellipsis: true,
        }, {
            title: '客户名称',
            width: 160,
            dataIndex: 'customerName',
        }, {
            title: '贸易国别',
            width: 160,
            dataIndex: 'countryName',
        }, {
            title: '币种',
            width: 120,
            dataIndex: 'currencyName',
        }, {
            title: '折算汇率',
            width: 80,
            dataIndex: "exchangeRate"
        }, {
            title: '价格条款',
            width: 80,
            dataIndex: "clause",
            render: (t) => getTreeNodeName(t)
        }, {
            title: '外贸合同金额',
            width: 120,
            dataIndex: 'contractAmount',
            render: (t, r) => `${r.currency}${formatNum(t)}`
        }, {
            title: '结算时间',
            width: 100,
            dataIndex: 'settlementTime',
            render: t => moment(t).format("YYYY-MM-DD")
        }, {
            title: '结算金额',
            width: 100,
            dataIndex: 'contractAmount',
            render: (t, r) => `${r.currency}${formatNum(t)}`
        }, {
            title: '累计已收',
            width: 100,
            dataIndex: 'cumulative',
            render: (t, r) => `${r.currency}${formatNum(t)}`
        }, {
            title: '未收金额',
            width: 100,
            dataIndex: 'uncollected',
            //aeo 这几个单据的未收金额展示成0
            render: (t, r) => `${r.currency}${["YHCY-NOR-2101", "YHCY-NOR-2103", "YHCY-XGYT-2106", "YHCY-NOR-2201", "YHEC2101"].indexOf(r.code ?? "") > -1 ? "0.00" : formatNum(t)}`
        }, {
            title: '收款明细',
            width: 80,
            align: "center",
            render: (t, r) => <span className="label-span" onClick={() => setDetailedDialog({ visible: true, row: r })}>详情</span>
        }
    ];


    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
